import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Whois extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M11.25,1.48a9.76,9.76,0,0,0-9,6H3.911A8.313,8.313,0,0,1,7.9,3.692,11.325,11.325,0,0,0,6.393,7.48H7.948c.68-2.755,2.036-4.5,3.3-4.5s2.622,1.745,3.3,4.5H16.1a11.317,11.317,0,0,0-1.5-3.788A8.313,8.313,0,0,1,18.589,7.48h1.658A9.762,9.762,0,0,0,11.25,1.48ZM0,8.98l1.468,6H2.883l.867-3.826.867,3.826H6.032l1.468-6H6l-.712,3.606L4.5,8.98H3l-.788,3.606L1.5,8.98Zm7.5,0,1.468,6h1.415l.867-3.829.495,2.2A6.539,6.539,0,0,0,10.9,19.43c-.906-.226-1.82-1.3-2.475-2.953H6.809A10.055,10.055,0,0,0,7.9,18.756a8.306,8.306,0,0,1-3-2.276H3.047a9.747,9.747,0,0,0,8.2,4.5c.128,0,.251-.021.378-.026a6.735,6.735,0,1,0,10.081-8.748L22.5,8.98H21l-.472,2.388c-.19-.107-.373-.225-.574-.314L19.5,8.98H18l-.337,1.541c-.139-.009-.271-.041-.413-.041s-.3.034-.445.044L16.5,8.98H15l.434,1.778a6.664,6.664,0,0,0-.95.328L15,8.98H13.5l-.621,3.15c-.053.046-.11.085-.161.132L12,8.98H10.5l-.788,3.606L9,8.98Zm9.75,3A5.25,5.25,0,1,1,12,17.23h0a5.239,5.239,0,0,1,5.228-5.25Zm-.75,1.5v1.5h.75a.75.75,0,0,1,0,1.5.75.75,0,0,0-.75.75v.75h.75a2.268,2.268,0,0,0,.688-.117L18,17.851v-.009a2.245,2.245,0,0,0-.75-4.362Zm0,6v1.5H18v-1.5Z" />
      </svg>
    );
  }
}

export default Whois;
